// import axios from "axios";
// import { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import { VictoryAnimation, VictoryLabel, VictoryPie } from "victory";

// export default function CircularProgressBar({ userId, userName }) {

//   const BASE_API_URL = process.env.REACT_APP_API_URL;

//   const [state, setState] = useState({
//     percent: 0,
//     data: [
//       { x: 1, y: 0 },
//       { x: 2, y: 100 }
//     ]
//   });

//   useEffect(() => {
//     let runCount = 0; // To track the number of times the function is called

//     const fetchPercentData = async () => {
//       try {
//         const response = await axios.get(`${BASE_API_URL}/userPercentage?userId=${userId}`);
//         const percent = response.data;

//         setState({
//           percent,
//           data: [
//             { x: 1, y: percent },
//             { x: 2, y: 100 - percent }
//           ]
//         });

//         runCount++; // Increment the run count

//         if (runCount >= 2) {
//           clearInterval(interval); // Clear interval after it runs 2 times
//         }
//       } catch (error) {
//         console.error("Error fetching completion percentage:", error);
//       }
//     };

//     // Set interval to fetch data every 2 seconds
//     const interval = setInterval(fetchPercentData, 1000);

//     // Call the function once immediately on mount
//     fetchPercentData();

//     // Clean up interval on component unmount
//     return () => clearInterval(interval);
//   }, [userId]);  // Re-fetch if userId changes

//   const handleButtonClick = () => {
//     // Use the history hook to navigate
//   };
//   return (
//     <div style={{ height: "320px" }}>
//       <h4 className="text-center">Profile Status</h4>
//       <svg viewBox="0 0 400 400" width="100%" height="100%">
//         <VictoryPie
//           standalone={false}
//           animate={{ duration: 1000 }}
//           width={400}
//           height={400}
//           data={state.data}
//           innerRadius={120}
//           cornerRadius={25}
//           labels={() => null}
//           style={{
//             data: {
//               fill: ({ datum }) => {
//                 const color = datum.y > 30 ? "green" : "red";
//                 return datum.x === 1 ? color : "transparent";
//               }
//             }
//           }}
//         />

//         <VictoryAnimation duration={1000} data={state}>
//           {(newProps) => (
//             <VictoryLabel
//               x={200}
//               y={200}
//               textAnchor="middle"
//               verticalAnchor="middle"
//               text={`${Math.round(newProps.percent)}%`}
//               style={{ fontSize: 45 }}
//             />
//           )}
//         </VictoryAnimation>
//       </svg>

//       {/* Conditional message below the chart */}
//       {state.percent < 100 && (
//         <div style={{ textAlign: "center", marginTop: "20px" }}>
//           <p style={{ fontSize: "18px", color: "red" }}>
//             {state.percent}% data you filled,{" "}
//             <Link
//               to="/candidate-dashboard/profile"
//               state={{ userName: userName, userId: userId }}
//             >
//               complete it now!
//             </Link>
//           </p>
//         </div>
//       )}
//       {state.percent === 100 && (
//         <div style={{ textAlign: "center", marginTop: "20px" }}>
//           <p style={{ fontSize: "18px"}}>
//             Your profile is 100% Completed
//           </p>
//         </div>
//       )}

//     </div>
//   );
// }

import axios from "axios";
import { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { VictoryAnimation, VictoryLabel, VictoryPie } from "victory";

export default function CircularProgressBar({ userId, userName }) {
  const BASE_API_URL = process.env.REACT_APP_API_URL;

  const [state, setState] = useState({
    percent: 0,
    fieldsWithData: [],
    pendingFields: [],
    data: [
      { x: 1, y: 0 },
      { x: 2, y: 100 }
    ]
  });

  useEffect(() => {
    let runCount = 0; // To track the number of times the function is called

    const fetchPercentData = async () => {
      try {
        const response = await axios.get(
          `${BASE_API_URL}/userPercentage?userId=${userId}`
        );

        const { percentage, fieldsWithData, pendingFields } = response.data;

        // Set state with the fetched data
        setState({
          percent: percentage,
          fieldsWithData: fieldsWithData,
          pendingFields: pendingFields,
          data: [
            { x: 1, y: percentage, label: "Completed" },
            { x: 2, y: 100 - percentage, label: "Pending" }
          ]
        });

        runCount++; // Increment the run count

        if (runCount >= 2) {
          clearInterval(interval); // Clear interval after it runs 2 times
        }
      } catch (error) {
        console.error("Error fetching completion percentage:", error);
      }
    };

    // Set interval to fetch data every 2 seconds
    const interval = setInterval(fetchPercentData, 1000);

    // Call the function once immediately on mount
    if(userId)
    fetchPercentData();

    // Clean up interval on component unmount
    return () => clearInterval(interval);
  }, [userId]); // Re-fetch if userId changes

  return (

    <Card >
     <Card.Title as="h4" className="mt-3 text-center">Profile Status</Card.Title>
      <Card.Body className="p-4">
        <div className="d-flex justify-content-center align-items-center" style={{ height: '280px' }}>
          <svg viewBox="0 0 400 400" width="100%" height="100%">
            <VictoryPie
              standalone={false}
              animate={{ duration: 1000 }}
              width={400}
              height={400}
              data={[
                { x: "Completed", y: state.percent },
                { x: "Pending", y: 100 - state.percent }
              ]}
              innerRadius={120}
              cornerRadius={25}
              labels={() => null}
              style={{
                data: {
                  fill: ({ datum }) =>
                    datum.x === "Completed"
                      ? datum.y > 30 ? "green" : "red"
                      : "rgba(169, 169, 169, 0.5)"
                }
              }}
            />

            <VictoryAnimation duration={1000} data={state}>
              {(newProps) => (
                <VictoryLabel
                  x={200}
                  y={200}
                  textAnchor="middle"
                  verticalAnchor="middle"
                  text={`${Math.round(newProps.percent)}%`}
                  style={{ fontSize: 45, fontWeight: 'bold' }}
                />
              )}
            </VictoryAnimation>
          </svg>
        </div>

        {/* Conditional Message */}
        {state.percent === 0 && (
          <div className="text-center mt-3">
            <p className="text-danger fw-bold" style={{ fontSize: "18px" }}>
              Please set your name and phone number first
            </p>
          </div>
        )}

        {/* Incomplete Profile */}
        {state.percent < 100 && (
          <div className="text-center mt-3">
            <p className="text-danger" style={{ fontSize: "18px" }}>
              {state.percent}% data you filled
            </p>
            <h6 className="fw-semibold">Pending Fields (click to complete):</h6>
            <div className="d-inline-block">
              {state.pendingFields.map((field, index) => (
                <span key={index}>
                  <Link
                    to={
                      field === "Resume"
                        ? "/candidate-dashboard/resume/resumeAdd"
                        : "/candidate-dashboard/profile"
                    }
                    state={{
                      userName: userName,
                      userId: userId,
                      preference: field
                    }}
                    style={{
                      fontSize: "16px",
                      fontWeight: "bold",
                      color: "#007bff",
                      textDecoration: "underline",
                      marginRight: '6px'
                    }}
                  >
                    {field}
                  </Link>
                  {index < state.pendingFields.length - 1 && <span>, </span>}
                </span>
              ))}
            </div>
          </div>
        )}

        {/* Completed Profile */}
        {state.percent === 100 && (
          <div className="text-center mt-3">
            <p className="text-success fw-semibold" style={{ fontSize: "18px" }}>
              Your profile is 100% Completed 🎉
            </p>
          </div>
        )}
      </Card.Body>
    </Card>

  );
}

